export default "__VITE_ASSET__CVVEmFwz__"